import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { isMobile } from 'react-device-detect';
import { ILoadedProps, IProps, ITableCellHeader } from './interface';
import { getAvailableFields, loadReport } from './api';
import { getJsonStorageTypes } from '../PageReportsList/api';

export const path = '/reports/:type/:id';
export const getPath = (id: string, type: string) => `/reports/${!!id ? `${type}/${id}` : `${type}`}`;

const getPage = () => {
  return isMobile ? import(`./page`) : import(`./page`);
};

const PageOrgStructure: React.FC<IProps> = (props) => {
  // @ts-ignore
  const reportId = props.match.params.id;
  // @ts-ignore
  const reportType = props.match.params.type;

  let loader = {
    page: () => getPage(),
    i18n: () => import(`./ru.json`),
    availableFields: getAvailableFields,
    jsonStorageTypes: getJsonStorageTypes,
  };

  if (reportId && reportId !== 'new') {
    loader = {
      ...loader,
      // @ts-ignore
      report: () => loadReport(parseInt(reportId)),
    };
  }
  const LoadableMap = Loadable.Map({
    loader: loader,
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps): React.ReactNode {
      const Page: any = loaded.page.default;
      let availableFields = loaded.availableFields.map((field: ITableCellHeader) => ({
        label: field.caption,
        value: field.columnName,
      }));
      const jsonStorageType = loaded.jsonStorageTypes.filter((item) => item.name === reportType)[0];
      return (
        <Page
          {...loadedProps}
          {...props}
          report={loaded.report ? loaded.report : null}
          jsonStorageType={jsonStorageType}
          reportId={reportId ? reportId : null}
          availableFields={availableFields}
          i18n={{ ...loaded.i18n }}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageOrgStructure;
